import React, { useState, useEffect, useContext } from "react";
// import SocketContext from "../../contexts/SocketContext";
// import useLogout from "../../hooks/useLogout";

// import Users from "../Users/Users";

const Dashboard = () => {
  //Import socket from context
  // const { socket } = useContext(SocketContext);

  //Socket status state
  // const [isConnected, setIsConnected] = useState(socket.connected);

  // Data states
  const [receivedmsg, setReceivedmsg] = useState("");

  // // Socket Connection and onLoad Queries
  // useEffect(() => {
  //   const onConnect = () => {
  //     setIsConnected(true);
  //     socket.emit("joindashboard", 123);
  //   };
  //   const onDisconnect = () => {
  //     setIsConnected(false);
  //   };
  //   socket.on("connect", onConnect);
  //   socket.on("disconnect", onDisconnect);
  //   socket.on("sendmsgback", (data) => {
  //     setReceivedmsg(data);
  //   });
  //   return () => {
  //     socket.off("connect", onConnect);
  //     socket.off("disconnect", onDisconnect);
  //   };
  // }, []);

  // useLogout
  // const logout = useLogout();

  // const signOut = async () => {
  //   // socket.disconnect();
  //   await logout();
  // };

  return (
    <>
      <div>Dashboard</div>
      {/* <div>{isConnected ? "online" : "offline"}</div> */}
      {/* <Users socket={socket} /> */}
      {receivedmsg ? receivedmsg : ""}
      {/* <button
        onClick={() => {
          signOut();
        }}
      >
        Log Out
      </button> */}
    </>
  );
};

export default Dashboard;
